"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabNavItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../colors");
const React = __importStar(require("react"));
const UnStyledTabNavItem = props => React.createElement("li", { className: props.className }, props.children);
exports.TabNavItem = (0, styled_components_1.default)(UnStyledTabNavItem) `
  position: relative;

  padding: 4px 35px 4px 10px;
  margin-right: 5px;

  border: 1px solid ${colors_1.tabNavBorderColor};
  border-bottom: 0;
  border-radius: 5px 5px 0 0;

  font-size: 14px;
  font-weight: bold;

  background: ${props => props.active
    ? "linear-gradient(to top, rgb(84, 192, 242), rgb(0, 168, 235))"
    : "linear-gradient(to top, rgb(252, 252, 252) 10%, rgb(238, 240, 236))"};

  a:link,
  a:visited,
  a:hover,
  a:active,
  a {
    color: ${props => (props.active ? "white" : "rgb(102, 102, 102)")};
    text-decoration: none;
  }

  &:hover {
    background: linear-gradient(to top, rgb(84, 192, 242), rgb(0, 168, 235));

    a:link,
    a:visited,
    a:hover,
    a:active,
    a {
      color: white;
    }
  }
`;
//# sourceMappingURL=tab-nav-item.js.map